import React, { useContext } from 'react'
import styled from 'styled-components';
import { LikutModals } from '../../../../../modules/Context/CefiNum';
import { FormShell, FormFooter } from '../../../../../generic/ui/FormLayout'
import { AccentButton } from '../../../../../generic/ui/Button'

export default function SuccessModal({ mood, title, text }) {
    const [resonState, setResonState] = useContext(LikutModals);
    const handleClick = () => { setResonState({ ...resonState, 'active': false }) }
    const buttonLabel = mood ? 'הבנתי'
        :
        'אחלה'
    return (
        <FormShell>
            <MessageText $mood={!!mood}>
                {text ? text : '! המשטח נשלח להדפסה '}
            </MessageText>
            <FormFooter>
                <AccentButton
                    type='button'
                    variant={mood ? 'danger' : 'accent'}
                    onClick={handleClick}
                    fullWidth={false}
                >
                    {buttonLabel}
                </AccentButton>
            </FormFooter>
        </FormShell>
    )
}

const MessageText = styled.p`
    width: 100%;
    margin: 0;
    padding: 0.5rem 0.25rem;
    direction: rtl;
    text-align: right;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.lg};
    color: ${({ theme, $mood }) => ($mood ? theme.colors.danger : theme.colors.ink)};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.lg};
    }
`
